//微信分享
// 初始化之后 配置 wxShareCom.init({
// title: '', // 分享标题
// desc: '', // 分享描述
// link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
// imgUrl: '', // 分享图标
// })

window.wxShareCom = {

  wxConfig: {
    weChatId: window.cateData.weChatId,
    appId:'',
    signature:'',
    timestamp:'',
    nonceStr:'',
    jsApiList:['updateAppMessageShareData','updateTimelineShareData'],

  },

  shareConfig: {
    title: '', // 分享标题
    desc: '', // 分享描述
    link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: '', // 分享图标
    success: function () {}, //设置成功后调用，注意不是分享后，或点击分享按钮调用。
  },

  //获取微信配置
  getWxConfig: function () {
    var _this = this;

    var url =  window.smk_api_host + '/weChat/getConfig';
    var parainfo = {
      'weChatId': _this.wxConfig.weChatId,
      'url':window.location.href,
      'jsApiList': _this.wxConfig.jsApiList,
      'onDebug': false,
      "_cache_with_cached": 1, //是否启用缓存 0/1
      "_cache_refresh": 0, //是否刷新缓存 0/1
      "_cache_timeout": 5*60, //缓存过期时间【秒】
      };

    postJson(url, parainfo, function (data) {
      if(data.body.result === 0){
        // userRecode({behaviorType: '微信分享', behaviorResult: '分享成功'});
        _this.wxConfig.appId = data.body.content.appId;
        _this.wxConfig.signature = data.body.content.signature;
        _this.wxConfig.timestamp = data.body.content.timestamp;
        _this.wxConfig.jsApiList = data.body.content.jsApiList;
        _this.wxConfig.nonceStr = data.body.content.nonceStr;

        _this.setWxConfig();
      }else{
        // msg.toast('获取微信配置失败');
      }
    });

  },

  //设置微信配置
  setWxConfig: function () {
    var _this = this;
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: _this.wxConfig.appId, // 必填，公众号的唯一标识
      timestamp: _this.wxConfig.timestamp, // 必填，生成签名的时间戳
      nonceStr: _this.wxConfig.nonceStr, // 必填，生成签名的随机串
      signature: _this.wxConfig.signature,// 必填，签名
      jsApiList: _this.wxConfig.jsApiList // 必填，需要使用的JS接口列表
    });

    _this.setShare();
  },

  //设置分享
  setShare: function () {
    var _this = this;
    wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
      //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      wx.updateAppMessageShareData({
        title: _this.shareConfig.title, // 分享标题
        desc: _this.shareConfig.desc, // 分享描述
        link: _this.shareConfig.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: _this.shareConfig.imgUrl, // 分享图标
        success: _this.shareConfig.returnFunc
      });

      // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
      wx.updateTimelineShareData({
        title: _this.shareConfig.title, // 分享标题
        link: _this.shareConfig.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: _this.shareConfig.imgUrl, // 分享图标
        success: _this.shareConfig.returnFunc
      })
    });
  },

  //处理分享链接，解决加参数失效的问题
  handelUrl: function(){
    if(this.shareConfig.link.indexOf('?') > -1){
      this.shareConfig.link = this.shareConfig.link + '&from=singlemessage&isappinstalled=0';
    }else{
      this.shareConfig.link = this.shareConfig.link + '?from=singlemessage&isappinstalled=0';
    }
  },

  init: function (shareInfo) {
    this.shareConfig = shareInfo;
    this.handelUrl();
    this.getWxConfig();
  }
};
